export default "__VITE_PUBLIC_ASSET__8c8fd0f2__"